import { useMutation, useQueryClient } from '@tanstack/react-query';
import { TCheckedRadioButtonSelection } from '@legacy/screens/ResourcePlanner/components/DistributeUnplannedWorkloadModalContent/DistributeUnplannedWorkloadModalContent';
import { reloadRpTables } from '@legacy/screens/ResourcePlanner/helper/reloadRpTables';
import { signalRConnectionIdKey } from '@legacy/screens/ResourcePlanner/sessionStorageKeys';
import { postFetch } from '@legacy/utils/fetcher';
import { formatUrl } from '@legacy/utils/url';

const POST_DISTRIBUTE_UNPLANNED_HOURS_URL_PATH =
  '/api/v2/resource-planner/smart-plan';

export const POST_DISTRIBUTE_UNPLANNED_HOURS_MSW_STATUS_KEY = 'SmartPlan';

interface IPostDistributeUnplannedHours {
  resourceId?: string;
  workItemId?: string;
  startsAt?: string;
  endsAt?: string;
  selectionType: TCheckedRadioButtonSelection;
}

export default () => {
  const path = formatUrl(POST_DISTRIBUTE_UNPLANNED_HOURS_URL_PATH);
  const hubConnectionId = sessionStorage.getItem(signalRConnectionIdKey);

  const postDistributeUnplannedHours = ({
    resourceId,
    workItemId,
    startsAt,
    endsAt,
    selectionType,
  }: IPostDistributeUnplannedHours) =>
    postFetch({
      path,
      key: POST_DISTRIBUTE_UNPLANNED_HOURS_MSW_STATUS_KEY,
      body: JSON.stringify({
        ResourceId: resourceId,
        WorkItemId:
          typeof workItemId === 'string' && workItemId.includes('_')
            ? workItemId.split('_')[1]
            : workItemId,
        StartsAt: startsAt,
        EndsAt: endsAt,
        SelectionType: selectionType,
        HubConnectionId: hubConnectionId,
      }),
    });
  const qc = useQueryClient();

  return useMutation({
    mutationFn: postDistributeUnplannedHours,

    onSuccess: () => {
      reloadRpTables(qc);
    },
  });
};
